<button
  tiime-button
  color="primary"
  icon
  [tiimeTooltip]="
    lastReminderDate ? 'Dernière relance : ' + (lastReminderDate | date: 'shortDate') : 'Relances du contrat'
  "
  [strocked]="strocked"
  (click)="$event.stopPropagation(); openContractReminderOverlay()"
>
  <mat-icon svgIcon="icon-mail-sync"></mat-icon>
</button>
@if (reminderCount > 0) {
  <div class="count-badge">{{ reminderCount }}</div>
}
@if (nextReminderDate | contractReminderLate) {
  <mat-icon class="late-badge" color="warn" svgIcon="icon-warning" tiimeTooltip="Relance en retard"></mat-icon>
}
<div class="overlay-anchor" #overlayAnchor></div>
